import React, { useState, useContext, useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import withForm from 'modules/common/hoc/withForm';
import Modal from 'modules/common/components/Modal';
import PropTypes from 'prop-types';
import useFormValidator from 'useFormValidator';
import { ModalContext } from 'App';

import * as actions from '../actions';
import * as c from '../constant';

function RejectConfirmationModal({
  createTextArea,
  reject,
  formData,
  setFormData,
  id,
  rejecting,
  getItem,
}) {
  const setModal = useContext(ModalContext);
  const [charCount, setCharCount] = useState(0);

  const handleOnKeyUp = e => {
    e.preventDefault();

    setCharCount(() => formData.remarks.length || 0);
  };

  const handleOnSubmit = e => {
    e.preventDefault();

    const args = {
      remarks: formData.remarks,
    };

    reject(id, args, () => {
      setModal({ isOpen: false });
      getItem(id);
    });
  };

  const closeModal = e => {
    e.preventDefault();
    setModal({ isOpen: false });
  };

  useEffect(() => {
    setFormData({
      ...formData,
      remarks: '',
    });
  }, []);

  let remarksValidation = {
    remarks: 'required',
  };

  const validateForm = useFormValidator(formData, remarksValidation);

  useEffect(() => {
    if (_.get(formData, 'remarks')) {
      remarksValidation = {
        ...formData,
        remarks: 'required|min_3_character',
      };
    }

    validateForm.onSetObjectRules(remarksValidation);
  }, [_.get(formData, 'remarks')]);

  return (
    <Modal.Body>
      <form onSubmit={handleOnSubmit}>
        <div className="row">
          <div className="col-12 form-group">
            <label>Are you sure, do you want reject this application?</label>
            <label className="full-label mb-0">
              Remarks: {charCount}/500 {validateForm.renderMessage('remarks')}
            </label>
            {createTextArea(
              { key: 'remarks' },
              { maxLength: '500', rows: '15', onKeyUp: handleOnKeyUp }
            )}
          </div>
        </div>
        <div className="d-flex justify-content-end">
          <button
            disabled={rejecting}
            type="submit"
            className="mt-3 btn btn-primary cms-bg-color-primary cms-outline-primary  mr-3   "
          >
            <span className="font-weight-bold">
              {rejecting ? <i className="fa fa-spin fa-spinner" /> : `Submit`}
            </span>
          </button>
          <button
            disabled={rejecting}
            type="button"
            onClick={closeModal}
            className="mt-3 btn btn-default"
          >
            <span className="font-weight-bold">Cancel</span>
          </button>
        </div>
      </form>
    </Modal.Body>
  );
}

RejectConfirmationModal.propTypes = {
  createTextArea: PropTypes.instanceOf(Function).isRequired,
  setFormData: PropTypes.instanceOf(Function).isRequired,
  formData: PropTypes.instanceOf(Object).isRequired,
  reject: PropTypes.instanceOf(Function).isRequired,
  getItem: PropTypes.instanceOf(Function).isRequired,
  id: PropTypes.string.isRequired,
  rejecting: PropTypes.bool.isRequired,
};

const mapStateToProps = ({ api }) => ({
  rejecting: api.loading.indexOf(c.REJECT) > -1,
});

const enhance = _.flowRight([
  withForm,
  withRouter,
  connect(mapStateToProps, {
    ...actions,
  }),
]);

export default enhance(RejectConfirmationModal);
